import { KycCurrentStatus, type KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';
import { isKycSubmitted } from './is-kyc-submitted';
import { isKycRequired } from './is-kyc-required';

export function shouldSubmitKyc(kycInfo?: KycResponse | null) {
  if (!kycInfo) return true;

  if (isKycSubmitted(kycInfo)) return false;
  if (isKycRequired(kycInfo)) return true;

  // No active process — only skip when status is accepted.
  // Accountant-hub users may have no active process while their kycCurrentStatus
  // is still pending, meaning they still need to complete KYC.
  return kycInfo.kycCurrentStatus === KycCurrentStatus.pending;
}
